import endpoints from '@/api/endpoints';
import { http, HttpResponse } from 'msw';

const API_BASE_URL = endpoints.baseURL;

export const calculateFeeHandler = http.post<object, any, any>(`${API_BASE_URL}${endpoints.calculateTransfersFee}`, async () =>
  HttpResponse.json({ fee: 5.0 })
);

export const createTransferHandler = http.post<object, any, any>(`${API_BASE_URL}${endpoints.newTransfer}`, async () =>
  HttpResponse.json({ id: 'transfer-created-001', status: 'PENDING' })
);

export const createCsvTransferHandler = http.post<object, any, any>(`${API_BASE_URL}${endpoints.newCsvTransfer}`, async () =>
  HttpResponse.json({ id: 'transfer-csv-001', status: 'PENDING' })
);

export const validateAccountsHandler = http.post<object, any, any>(`${API_BASE_URL}${endpoints.getAccountsInf}`, async ({ request }) => {
  const body = await request.json().catch(() => ({ transferRequests: [] }));
  const results = (body.transferRequests ?? []).map((req: any) => ({
    accountNumber: req.accountNumber,
    recipientName: 'MOCK RECIPIENT',
    valid: true,
    branchCode: '0001',
    bankCode: '36035',
  }));
  return HttpResponse.json({ transferValidations: results });
});

export const getAccountInfoHandler = http.get<object, any, any>(`${API_BASE_URL}${endpoints.getAccountInf}`, async () =>
  HttpResponse.json({
    accountNumber: '000107794061-11',
    firstName: 'YVES NARCISSE',
    lastName: 'FEUGWO FEUKOUO',
    accountTitle: 'COMPTES COURANTS ORDINAIRES',
    branchCode: '0001',
    bankCode: '36035',
    currency: 'USD',
  })
);

export const getDeferredTransfersHandler = http.get<object, any, any>(`${API_BASE_URL}${endpoints.getTransfers}`, async () =>
  HttpResponse.json({
    data: [
      {
        id: 'deferred-001',
        account: '00010804501-75',
        recipientAccountNumber: '000107794061-11',
        currency: 'USD',
        amount: 750,
        fee: 5,
        reason: 'Scheduled payment',
        status: 'SCHEDULED',
        externalTransfer: true,
        bankCode: '10001',
        branchCode: '0001',
        executionDateTime: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString(), // +2 days
        notificationEnabled: false,
        fromAccount: '00010804501-75',
        type: 'INTERNAL',
        recipientName: 'YVES NARCISSE FEUGWO FEUKOUO',
      },
    ],
    data2: [],
    size: 5,
    totalElements: 1,
    totalPages: 1,
    number: 0,
  })
);

export const editDeferredTransferHandler = http.put<{ id: string }, any, any>(`${API_BASE_URL}/payment/transfers/:id/deferred`, async () =>
  HttpResponse.json({ message: 'Transfer updated' })
);

export const deleteDeferredTransferHandler = http.delete<{ id: string }, any, any>(
  `${API_BASE_URL}/payment/transfers/:id/deferred`,
  async () => HttpResponse.json({ message: 'Transfer deleted' })
);

export const otpPaymentHandler = http.post<object, any, any>(`${API_BASE_URL}${endpoints.otpPayment}`, async () =>
  HttpResponse.json({
    message: { en: 'OTP sent', fr: 'OTP envoyé' },
    isOtpBlocked: false,
  })
);

export const getSwiftTransfersHandler = http.get<object, any, any>(`${API_BASE_URL}${endpoints.getSwiftTransfers}`, async () =>
  HttpResponse.json({ data: [], size: 5, totalElements: 0, totalPages: 0, number: 0 })
);

export const createInternationalTransferHandler = http.post<object, any, any>(
  `${API_BASE_URL}${endpoints.newInternationalTransfer}`,
  async () => HttpResponse.json({ id: 'swift-created-001', status: 'PENDING' })
);

export const transferHandlers = [
  calculateFeeHandler,
  createTransferHandler,
  createCsvTransferHandler,
  validateAccountsHandler,
  getAccountInfoHandler,
  getDeferredTransfersHandler,
  getSwiftTransfersHandler,
  editDeferredTransferHandler,
  deleteDeferredTransferHandler,
  otpPaymentHandler,
  createInternationalTransferHandler,
];
